<template>
  <div class="body">
    <!-- 添加面包屑导航 -->
    <div class="van-breadcrumb">
      <!-- 手动添加 Home 链接 -->
      <router-link
        to="/"
        class="van-breadcrumb__item van-breadcrumb__item--home"
      >
        首页
      </router-link>
      <span class="van-breadcrumb__separator">></span>
      <span
        v-for="(item, index) in $route.matched"
        :key="index"
        class="van-breadcrumb__item"
        :class="{
          'van-breadcrumb__item--active': index === $route.matched.length - 1,
        }"
      >
        <!-- 分隔符只在前一个路由项和当前路由项之间显示 -->
        <span class="van-breadcrumb__separator" v-if="index > 0">></span>
        <router-link
          v-if="index < $route.matched.length - 1"
          :to="item.path"
          class="van-breadcrumb__link"
        >
          {{ item.meta.display || item.name || item.path }}
        </router-link>
        <span v-else>{{ item.meta.display || item.name || item.path }}</span>
      </span>
      <!-- 最后一个分隔符在循环外部，但只在前一个路由项存在时显示 -->
      <span class="van-breadcrumb__separator" v-if="$route.matched.length > 1"
        >></span
      >
    </div>

    <!-- 过滤条件 -->
    <div class="filter-container">
      <h1>发票报销记录</h1>
      <div class="filter-content">
        <div class="filter-content-left">
          <el-date-picker
            style="width: 100%"
            v-model="selectDate"
            type="month"
            placeholder="选择查询年月"
            format="yyyy-MM"
            value-format="yyyy-MM"
            @change="handleChange"
          >
          </el-date-picker>
        </div>

        <div class="filter-content-right">
          <el-select
            v-model="selectedType"
            clearable
            class="filter-input"
            placeholder="选择类型"
          >
            <el-option v-for="type in types" :key="type" :value="type">
              {{ type }}
            </el-option>
          </el-select>
        </div>
      </div>

      <div class="filter-button-container">
        <!-- 按钮 -->
        <div class="button-container">
          <button @click="queryData" class="filter-button">查询</button>
        </div>
        <!--  <button
          @click="exportData"
          :disabled="!tableData.length"
          class="export-button"
        >
          导出
        </button>
         -->
        <download-excel
          class="export-download"
          :fields="json_fields"
          :header="exportName"
          :name="exportName"
          :worksheet="exportSheet"
          :footer="exportFooter"
          :data="tableData"
        >
          <!-- 添加一个容器来包裹按钮 -->
          <button class="export-button" :disabled="!showTable">导出</button>
        </download-excel>
      </div>

      <!-- 表格数据 -->
      <div class="table-data">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column
            prop="invoice_date"
            label="开票时间"
            width="110px"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="number"
            label="票号"
            width="110px"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="amount"
            label="金额"
            width="110px"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="typeName"
            label="类型"
            width="50px"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="operate"
            label="操作员"
            width="70px"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="unit_name"
            label="单位"
            width="70px"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="operate_time"
            label="报销时间"
            width="180px"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="voucher_number"
            label="凭证号"
            width="100px"
            align="center"
          ></el-table-column>
          <!-- 其他列... -->
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { queryInvoiceRecord } from "../api/index";
import { Toast } from "vant";
let moment = require("moment");

export default {
  computed: {
    breadcrumbs() {
      // 假设每个路由记录的 meta.breadcrumb 都有一个 title 和 path 属性
      return this.$route.matched
        .filter((record) => record.meta.breadcrumb)
        .map((record) => ({
          title: record.meta.breadcrumb.title,
          path: record.path,
        }));
    },
  },
  data() {
    return {
      showTable: false,
      selectDate: "",
      selectedType: "",
      userInfo: {
        user: "",
        unit: "",
      },
      types: ["专票", "普票"],
      exportName: "发票报销记录",
      exportSheet: "sheet",
      exportFooter: "",
      tableData: [], // 存放用于导出excel的数据
      json_fields: {
        开票时间: {
          field: "invoice_date", //常规字段
          callback: (value) => {
            return `${moment(value).format("YYYY年MM月DD日")}`;
          },
        },
        票号: {
          field: "number", //支持嵌套属性
          callback: (value) => {
            return `${"'" + value}`;
          },
        },
        金额: "amount",
        类型: "typeName",
        操作员: "operate",
        单位: "unit_name",
        报销时间: "operate_time",
        凭证号: "voucher_number",
      },
      json_meta: [
        [
          {
            " key ": " charset ",
            " value ": " utf- 8 ",
          },
        ],
      ],
    };
  },

  methods: {
    //日期选择触发
    handleChange(selectDate) {
      if (selectDate)
        this.exportName =
          moment(selectDate).format("YYYY年MM月") + this.exportName; // 选择的年月值
      // 在这里处理年月选择的变化
    },
    async queryData() {
      const params = {
        date: this.selectDate,
        type: this.selectedType,
        unit: this.userInfo.unit,
      };
      if (this.selectDate) {
        try {
          //console.log(this.unitName);
          //console.log(params);
          //发送请求
          queryInvoiceRecord(params).then((res) => {
            //console.log(res);
            if (res.code === 0) {
              this.tableData = res.data; // 假设服务器返回了表格数据
              this.showTable = true; // 显示表格
            } else {
              Toast({
                message: res.message,
                position: "middle",
                duration: 2000,
              });
            }
          });
        } catch (error) {
          Toast({ message: error, position: "middle", duration: 2000 });
        }
      } else {
        Toast({
          message: "请选择查询月份",
          position: "middle",
          duration: 2000,
        });
      }
    },
  },
  created() {
    this.selectDate = moment(new Date()).format("YYYY-MM-DD"); // 选择的年月值
    this.selectedType = this.types[0];
    // 在组件创建时从 localStorage 读取 userInfo
    let userInfoStr = localStorage.getItem("userInfo");
    if (userInfoStr) {
      this.userInfo = JSON.parse(userInfoStr);
    }
  },
};
</script>

<style scoped>
/* 基础样式 */
body {
  /* 设置一个固定的最大宽度 */
  max-width: 512px; /* 根据你的需求调整这个值 */
  /* 使用margin: auto来水平居中 */
  margin-left: auto;
  margin-right: auto;
  border: 1px solid #ddd;
  font-family: "Roboto", sans-serif;
  box-sizing: border-box;
  background-color: #f5f5f5;
}

h1 {
  margin: 0;
  padding: 15px 0 15px 0;
  color: #555;
  font-size: 24px;
  text-align: center;
  /* 其他样式... */
}
/* 面包屑容器 */
.van-breadcrumb {
  display: flex;
  align-items: center;
  padding: 16px 0 0 16px;
  margin: 0;
  list-style: none; /* 移除默认的列表样式 */
  font-size: 14px; /* 字体大小 */
  color: #999; /* 默认文本颜色 */
  overflow: hidden; /* 防止面包屑溢出容器 */
}

/* 面包屑项 */
.van-breadcrumb__item {
  display: flex;
  align-items: center;
  color: inherit; /* 继承容器颜色 */
  text-decoration: none; /* 移除下划线 */
  transition: color 0.3s; /* 文本颜色过渡效果 */
}

/* 当前激活的面包屑项 */
.van-breadcrumb__item--active {
  color: #333; /* 活动状态的文本颜色 */
  font-weight: bold; /* 可选，用于强调 */
}

/* 面包屑链接 */
.van-breadcrumb__link {
  color: inherit; /* 继承父元素颜色 */
  text-decoration: none; /* 移除下划线 */
  transition: color 0.3s; /* 链接文本颜色过渡效果 */
}

/* 面包屑链接的悬停样式 */
.van-breadcrumb__link:hover {
  color: #409eff; /* 悬停时的文本颜色 */
  text-decoration: underline; /* 添加下划线 */
}

/* 面包屑项之间的分隔符 */
.van-breadcrumb__separator {
  margin: 0 8px; /* 分隔符的左右间距 */
  color: #ccc; /* 分隔符的颜色 */
}

/* 处理最后一个分隔符不显示的问题（如果有需要） */
.van-breadcrumb__item:last-child .van-breadcrumb__separator {
  display: none;
}

/* 根据需要添加的其他样式 */
/* ... */

/* 过滤内容样式 */
.filter-content {
  display: flex;
  justify-content: flex-start; /* 使得左右两侧的内容间隔相等 */
  align-items: center; /* 垂直居中对齐 */
  box-sizing: border-box; /* 确保内边距不会增加元素的总宽度 */
}

.filter-content-left {
  padding: 8px 8px 0 8px;
  width: 48%;
}
/* 日期选择器样式 */
.filter-content-left .el-date-picker {
  min-width: 35%; /* 缩小年月选择器的宽度 */
}
.filter-label {
  margin: 0;
  padding: 0;
  width: 10px;
}

/* 类型选择器样式 */
.filter-content-right {
  padding: 8px 8px 0 8px;
  display: flex; /* 使用flex布局以垂直居中 */
  flex-direction: row; /* 垂直方向堆叠 */
  align-items: center; /* 垂直居中对齐 */
  width: 52%; /* 缩小年月选择器的宽度 */
  box-sizing: border-box; /* 确保内边距不会增加元素的总宽度 */
}

.filter-input {
  height: 38px; /* 假设这是年月选择器的高度，让类型选择器与之同高 */
  opacity: 1 !important; /*   ios悬停状态有问题，造成el-select下拉框需要点击两次才能选中----解决此问题   */
}
.export-download {
  display: flex;
  flex-direction: column; /* 或者根据你的需求改为 row */
  align-items: center;
  justify-content: center;
  width: 48%; /* 假设这是你需要的宽度 */
}

.button-container {
  /* 新增的容器样式 */
  width: 48%; /* 确保容器占满父元素宽度 */
  display: flex; /* 使用flex布局来确保按钮居中（如果需要的话） */
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
}
/* 按钮样式 */
.filter-button,
.export-button {
  height: 40px; /* 增加按钮的高度 */
  line-height: 36px; /* 调整行高以垂直居中文字 */
  background-color: #409eff; /* 给查询按钮添加背景色 */
  color: #fff; /* 查询按钮文字颜色 */
  border: none; /* 移除边框 */
  border-radius: 4px; /* 添加圆角 */
  font-size: 16px; /* 字体大小 */
  width: 100%;
  margin: 0;
}

/* 类型选择器和标签样式（如果需要的话） */
.filter-label,
.filter-input {
  display: block; /* 确保它们垂直堆叠 */
  width: 100%; /* 使得标签和输入框占满整个右侧容器 */
}

/* 查询和导出按钮样式 */
.filter-button-container {
  padding: 0 8px 0 8px;
  display: flex;
  justify-content: space-between; /* 使得按钮分布在两端 */
  align-items: center;
  margin-top: 16px; /* 与上面的内容保持一些间距 */
  width: 95%;
}

/* 禁用状态按钮样式 */
.export-button:disabled {
  background-color: #ddd; /* 禁用时颜色变浅 */
  color: #999;
  cursor: not-allowed;
}
/* 去除默认样式（如苹果会显示大圆角）  */
select {
  -webkit-appearance: none; /* 移除默认样式 */
  -moz-appearance: none; /* 同上 */
  -ms-appearance: none; /* 同上 */
  appearance: none; /* 同上 */
  /* 添加自定义样式 */
  background-color: #fff; /* 背景色 */
  border: 1px solid #ccc; /* 边框 */
  border-radius: 0; /* 圆角 */
  padding: 5px; /* 内边距 */
  font-size: 16px; /* 字体大小 */
  /* 其他需要的样式 */
}
.table-data {
  margin-top: 8px;
  /* 允许水平滚动 */
  overflow-x: auto;
  /* 可以根据需要添加其他样式，如 padding、margin 等 */
}
</style>
